<script lang="ts" type="module">
    export let item: any
</script>

<div class="post">
    <div class="item">
        <div class="image"><img src="{item.image}" alt="" /></div>
        <div class="text">
            {#if item.cat}
                <div class="cat">{item.cat}</div>
            {/if}
            <div class="inner">
                <h3>{item.title}</h3>
                {#if item.content}
                    <p>{item.content}</p>
                {/if}
            </div>
            <a
                href="{item.link}"
                target="_blank"
                rel="noreferrer"
                class="btn"
                noroute>Download</a
            >
        </div>
    </div>
</div>

<style lang="less">
    @import "../css/base.less";

    // List
    .post {
        width: 50%;
        @media (max-width: 920px) {
            width: 100%;
        }
    }
    .item {
        background: #fff;
        -webkit-box-shadow: 0px 0px 20px 3px rgba(0, 0, 0, 0.1);
        box-shadow: 0px 0px 20px 3px rgba(0, 0, 0, 0.1);
        .transition();
        .flex();
        .image {
            width: 200px;
            height: 350px;
            flex-shrink: 0;
            @media (max-width: 1400px) {
                width: 15vw;
                height: 100%;
            }
            @media (max-width: 1024px) {
                width: 12vw;
                height: 100%;
            }
            @media (max-width: 920px) {
                width: 15vw;
                height: 100%;
            }
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .text {
            padding: 20px;
            .flex();
            flex-direction: column;
            align-items: flex-start;
            .cat {
                line-height: 1.2;
                display: inline-block;
                background: #878787;
                padding: 5px 20px;
                color: #fff;
                font-size: 0.8rem;
                font-weight: 700;
                margin-bottom: 10px;
            }
            h3 {
                font-size: 1.1rem;
                margin: 0px 0px 20px 0px;
                color: @textcolor;
                @media (max-width: 1120px) {
                    font-size: 1rem;
                }
                a {
                    color: @textcolor;
                    .transition();
                }
            }
        }
        &:hover {
            -webkit-box-shadow: 0px 0px 23px 5px rgba(0, 0, 0, 0.2);
            box-shadow: 0px 0px 23px 5px rgba(0, 0, 0, 0.2);
        }
    }

    // Single
</style>
